import { createTheme, ThemeProvider, StyledEngineProvider, LegacyThemeProvider } from 'external/material';

const theme = createTheme();

export {theme as default, ThemeProvider, StyledEngineProvider, LegacyThemeProvider}